import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
  getActivityByJoinId({ rootState }, opt) { // 通过joinId获取全部活动
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity/GetShortByJoinId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  GetLiveShortByJoinId({ rootState }, opt) { // 通过joinId获取全部活动 live版本
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity/GetLiveShortByJoinId?topic=-1`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getActivityByJoinIdAll({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity/GetByJoinId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getActivityById({ rootState }, id) { // 根据id查询对应活动
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/activity/?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  setActivityShow({ rootState }, opt) { //修改活动屏蔽、显示
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/activity/SetShow`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addActivity({ rootState }, opt) { // 添加活动
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delActivity({ rootState }, id) { // 删除活动
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/activity?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editActivity({ rootState }, opt) { // 修改活动
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/Activity`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 